export enum ExternalScriptType {
  Style = 'style',
  Script = 'script'
}
